import { _ as r } from "../internals/export.js";
import { f as a } from "../internals/flatten-into-array.js";
import { a as t } from "../internals/a-callable.js";
import { t as o } from "../internals/to-object.js";
import { l as s } from "../internals/length-of-array-like.js";
import { a as e } from "../internals/array-species-create.js";
r({
  target: "Array",
  proto: !0
}, {
  flatMap: function flatMap(r) {
    var n,
      i = o(this),
      l = s(i);
    return t(r), (n = e(i, 0)).length = a(n, i, i, l, 0, 1, r, arguments.length > 1 ? arguments[1] : void 0), n;
  }
});